var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBMoreThree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 5.65322C10.8494 5.65322 11.5386 4.96399 11.5386 4.11476C11.5386 3.26552 10.8494 2.57629 10.0001 2.57629C9.1509 2.57629 8.46167 3.26552 8.46167 4.11476C8.46167 4.96399 9.1509 5.65322 10.0001 5.65322ZM10.0001 7.96091C9.1509 7.96091 8.46167 8.65014 8.46167 9.49937C8.46167 10.3486 9.1509 11.0378 10.0001 11.0378C10.8494 11.0378 11.5386 10.3486 11.5386 9.49937C11.5386 8.65014 10.8494 7.96091 10.0001 7.96091ZM8.46167 14.884C8.46167 14.0348 9.1509 13.3455 10.0001 13.3455C10.8494 13.3455 11.5386 14.0348 11.5386 14.884C11.5386 15.7332 10.8494 16.4224 10.0001 16.4224C9.1509 16.4224 8.46167 15.7332 8.46167 14.884Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_1285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 4,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 5.65322C10.8494 5.65322 11.5386 4.96399 11.5386 4.11476C11.5386 3.26552 10.8494 2.57629 10.0001 2.57629C9.1509 2.57629 8.46167 3.26552 8.46167 4.11476C8.46167 4.96399 9.1509 5.65322 10.0001 5.65322ZM10.0001 7.96091C9.1509 7.96091 8.46167 8.65014 8.46167 9.49937C8.46167 10.3486 9.1509 11.0378 10.0001 11.0378C10.8494 11.0378 11.5386 10.3486 11.5386 9.49937C11.5386 8.65014 10.8494 7.96091 10.0001 7.96091ZM8.46167 14.884C8.46167 14.0348 9.1509 13.3455 10.0001 13.3455C10.8494 13.3455 11.5386 14.0348 11.5386 14.884C11.5386 15.7332 10.8494 16.4224 10.0001 16.4224C9.1509 16.4224 8.46167 15.7332 8.46167 14.884Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_1285)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.769287,
    y: 0.268555,
    width: 18.4615,
    height: 18.4615,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBMoreThree);
export default __webpack_public_path__ + "static/media/B_more_three.5bbbb828754ed2f1f4a5c5c92a7df1a9.svg";
export { ForwardRef as ReactComponent };